export default "__VITE_ASSET__8d6E3w$A__"